export const MilesDrivenOnCurrentTires = {
  None: 0,
  Under10k: 1,
  From10kTo20k: 2,
  Over25k: 3,
}
